// Static game data: reasons, deciding factors, difficulty, daily matchups, archetypes.

export const REASONS = [
  { id: "attractive", label: "More attractive", group: "attraction" },
  { id: "creative", label: "More creative", group: "creative" },
  { id: "funnier", label: "Funnier", group: "humor" },
  { id: "intelligent", label: "More intelligent", group: "creative" },
  { id: "authentic", label: "More authentic", group: "values" },
  { id: "charismatic", label: "More charismatic", group: "attraction" },
  { id: "kinder", label: "Kinder", group: "values" },
  { id: "emotional", label: "More emotionally interesting", group: "values" },
  { id: "values", label: "Stronger values", group: "values" },
  { id: "cultural", label: "Greater cultural impact", group: "creative" },
  { id: "conversationalist", label: "Better conversationalist", group: "humor" },
  { id: "adventurous", label: "More adventurous", group: "creative" },
  { id: "mysterious", label: "More mysterious", group: "creative" },
  { id: "confident", label: "More confident", group: "attraction" },
  { id: "talented", label: "More talented", group: "creative" },
  { id: "instinct", label: "Pure instinct", group: "instinct" },
];

// groups used by results scoring
export const CREATIVE_GROUP = new Set(["creative", "intelligent", "cultural", "mysterious", "adventurous", "talented"]);
export const VALUES_GROUP = new Set(["authentic", "kinder", "values", "emotional"]);

export const DECIDING_FACTORS = [
  "Attraction",
  "Personality",
  "Intelligence",
  "Humor",
  "Creativity",
  "Overall Talent",
  "Values",
  "Emotional connection",
  "Cultural impact",
  "Lifestyle",
  "Instinct",
];

export const DIFFICULTIES = [
  { id: "easy", label: "Easy" },
  { id: "difficult", label: "Difficult" },
  { id: "nearly", label: "Nearly impossible" },
  { id: "irreconcilable", label: "Irreconcilable" },
];

// Daily matchups (5) - seeded majority percentages
export const DAILY_MATCHUPS = [
  { id: "r1", aId: "c1", bId: "c2", majorityId: "c1", majorityPct: 58 }, // Keanu vs Gosling
  { id: "r2", aId: "c9", bId: "c10", majorityId: "c9", majorityPct: 54 }, // Bowie vs Prince
  { id: "r3", aId: "c17", bId: "c18", majorityId: "c17", majorityPct: 61 }, // Serena vs Simone
  { id: "r4", aId: "c11", bId: "c12", majorityId: "c12", majorityPct: 55 }, // Elvis vs Lennon
  { id: "r5", aId: "c3", bId: "c4", majorityId: "c3", majorityPct: 52 }, // RDJ vs Rockwell
];

export const ARCHETYPES = {
  creative_contrarian: {
    id: "creative_contrarian",
    title: "Creative Contrarian",
    tagline: "Originality over popularity.",
    description: "You often chose the less-obvious pick and let creativity, culture, and mystery decide. You disagree with the crowd a lot — on purpose.",
    surprise: "You were most drawn to underdogs when cultural impact was on the line.",
  },
  cultural_insider: {
    id: "cultural_insider",
    title: "Cultural Insider",
    tagline: "You get the room.",
    description: "You consistently understood public opinion and valued cultural influence. You feel the zeitgeist before it names itself.",
    surprise: "You predicted the majority even in the matchups you personally disagreed with.",
  },
  thoughtful_idealist: {
    id: "thoughtful_idealist",
    title: "Thoughtful Idealist",
    tagline: "Kindness. Values. Depth.",
    description: "Authenticity, kindness, values and emotional depth guided most of your choices. Substance beats spectacle for you.",
    surprise: "You picked warmth over charisma more than 60% of the time.",
  },
  instinctive_picker: {
    id: "instinctive_picker",
    title: "Instinctive Picker",
    tagline: "Confident, fast, unbothered.",
    description: "Attraction, charisma, and instinct led. You made fast, confident picks without second-guessing.",
    surprise: "Your quickest choices were the ones you found hardest to defend later.",
  },
  crowd_whisperer: {
    id: "crowd_whisperer",
    title: "Crowd Whisperer",
    tagline: "You read the room without looking.",
    description: "You predicted the majority accurately across most rounds — even when your own choice differed.",
    surprise: "You called the biggest upset of the day.",
  },
};
